
const i18n = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/dashboard-cards');

export const tipNames = {
  importHelp: 'importHelp',
  importVideo: 'importVideo',
  broadMatchVideo: 'broadMatchVideo',
  extaVideo: 'extaVideo',
  extaHelp1: 'extaHelp1',
  extaHelp2: 'extaHelp2',
  sitelinksMktg: 'sitelinksMktg',
  sitelinksHelp: 'sitelinksHelp',
  calloutsMktg: 'calloutsMktg',
  calloutsHelp: 'calloutsHelp',
  structSnipHelp: 'structSnipHelp',
  structSnipMktg: 'structSnipMktg',
  dsa: 'dsa',
  conversionTrackingVideo: 'conversionTrackingVideo',
  remarketingTour: 'remarketingTour',
  remarketingHelp1: 'remarketingHelp1',
  remarketingVideo: 'remarketingVideo',
  remarketingHelp2: 'remarketingHelp2',
  autoBidHelp: 'autoBidHelp',
  autoBidMktg: 'autoBidMktg',
  sharedBudgetsHelp: 'sharedBudgetsHelp',
  callMktg: 'callMktg',
  callHelp: 'callHelp',
  reviewsMktg: 'reviewsMktg',
  reviewsHelp: 'reviewsHelp',
  kWMatchTypeHelp: 'kWMatchTypeHelp',
  kWMatchTypeMktg: 'kWMatchTypeMktg',
  negKWHelp1: 'negKWHelp1',
  negKWHelp2: 'negKWHelp2',
  broadMatchHelp: 'broadMatchHelp',
  ScheduledImportHelp: 'ScheduledImportHelp',
  ReImportRSACampaigns: 'ReImportRSACampaigns',
  IncludeRSACampaigns: 'IncludeRSACampaigns',
  IncludeMultiAccountGoogleImport: 'IncludeMultiAccountGoogleImport',
  ProvideStoreToImportShoppingCampaign: 'ProvideStoreToImportShoppingCampaign',
  SelectAdCusFeedToImportEXTA: 'SelectAdCusFeedToImportEXTA',
  FacebookImport: 'FacebookImport',
  UETCombineClarity: 'UETCombineClarity',
};

export const tipsConfig = {
  101: {
    tipName: tipNames.importHelp,
    title: i18n.getString('Dashboard_TipCard_Import_Help_Title'),
    description: i18n.getString('Dashboard_TipCard_Import_Help_Desc'),
    helpLink: 'app54577',
    helpType: 'side_pane',
    imgClass: 'import_tip_img',
    isImportRelatedTip: true,
  },
  102: {
    tipName: tipNames.importVideo,
    title: i18n.getString('Dashboard_TipCard_Import_Video_Title'),
    description: i18n.getString('Dashboard_TipCard_Import_Video_Desc'),
    helpLink: '1xyCD6fbf70',
    helpType: 'video',
    imgClass: 'import_tip_img',
    isImportRelatedTip: true,
  },
  202: {
    tipName: tipNames.broadMatchVideo,
    title: i18n.getString('Dashboard_TipCard_BroadMatch_Video_Title'),
    description: i18n.getString('Dashboard_TipCard_BroadMatch_Video_Desc'),
    helpLink: 'rYoAn-lZdJs',
    helpType: 'video',
    imgClass: 'broadMatch_tip_img',
  },
  // video no longer available on youtube
  /*
  301: {
    tipName: tipNames.extaVideo,
    title: i18n.getString('Dashboard_TipCard_EXTA_Video_Title'),
    description: i18n.getString('Dashboard_TipCard_EXTA_Video_Desc'),
    helpLink: 'YJCaOCLfWms',
    helpType: 'video',
    imgClass: 'exta_tip_img',
  },
  */
  302: {
    tipName: tipNames.extaHelp1,
    title: i18n.getString('Dashboard_TipCard_EXTA_Help1_Title'),
    description: i18n.getString('Dashboard_TipCard_EXTA_Help1_Desc'),
    helpLink: 'app54589',
    helpType: 'side_pane',
    imgClass: 'exta_tip_img',
  },
  303: {
    tipName: tipNames.extaHelp2,
    title: i18n.getString('Dashboard_TipCard_EXTA_Help2_Title'),
    description: i18n.getString('Dashboard_TipCard_EXTA_Help2_Desc'),
    helpLink: 'app54589',
    helpType: 'side_pane',
    imgClass: 'exta_tip_img',
  },
  401: {
    tipName: tipNames.sitelinksMktg,
    title: i18n.getString('Dashboard_TipCard_Sitelinks_Mktg_Title'),
    description: i18n.getString('Dashboard_TipCard_Sitelinks_Mktg_Desc'),
    helpLink: 'https://advertise.bingads.microsoft.com/en-us/solutions/ad-extensions/sitelink-extensions',
    helpType: 'new_page',
    imgClass: 'sitelinks_tip_img',
  },
  402: {
    tipName: tipNames.sitelinksHelp,
    title: i18n.getString('Dashboard_TipCard_Sitelinks_Help_Title'),
    description: i18n.getString('Dashboard_TipCard_Sitelinks_Help_Desc'),
    helpLink: 'app54652',
    helpType: 'side_pane',
    imgClass: 'sitelinks_tip_img',
  },
  501: {
    tipName: tipNames.calloutsMktg,
    title: i18n.getString('Dashboard_TipCard_Callouts_Mktg_Title'),
    description: i18n.getString('Dashboard_TipCard_Callouts_Mktg_Desc'),
    helpLink: 'https://advertise.bingads.microsoft.com/en-us/solutions/ad-extensions/callout-extensions',
    helpType: 'new_page',
    imgClass: 'callouts_tip_img',
  },
  502: {
    tipName: tipNames.calloutsHelp,
    title: i18n.getString('Dashboard_TipCard_Callouts_Help_Title'),
    description: i18n.getString('Dashboard_TipCard_Callouts_Help_Desc'),
    helpLink: 'app54575',
    helpType: 'side_pane',
    imgClass: 'callouts_tip_img',
  },
  601: {
    tipName: tipNames.structSnipHelp,
    title: i18n.getString('Dashboard_TipCard_StructSnip_Help_Title'),
    description: i18n.getString('Dashboard_TipCard_StructSnip_Help_Desc'),
    helpLink: 'app54578',
    helpType: 'side_pane',
    imgClass: 'structSnip_tip_img',
  },
  602: {
    tipName: tipNames.structSnipMktg,
    title: i18n.getString('Dashboard_TipCard_StructSnip_Mktg_Title'),
    description: i18n.getString('Dashboard_TipCard_StructSnip_Mktg_Desc'),
    helpLink: 'https://advertise.bingads.microsoft.com/en-us/blog/post/september-2016/new!-easily-highlight-your-products-and-services-with-structured-snippets',
    helpType: 'new_page',
    imgClass: 'structSnip_tip_img',
  },
  701: {
    tipName: tipNames.dsa,
    title: i18n.getString('Dashboard_TipCard_DSA_Help_Title'),
    description: i18n.getString('Dashboard_TipCard_DSA_Help_Desc'),
    helpLink: 'app54588',
    helpType: 'side_pane',
    imgClass: 'dsa_tip_img',
  },
  801: {
    tipName: tipNames.conversionTrackingVideo,
    title: i18n.getString('Dashboard_TipCard_ConversionTracking_Video_Title'),
    description: i18n.getString('Dashboard_TipCard_ConversionTracking_Video_Desc'),
    helpLink: 'IQbuhowpV3c',
    helpType: 'video',
    imgClass: 'conversionTracking_tip_img',
  },
  901: {
    tipName: tipNames.remarketingTour,
    title: i18n.getString('Dashboard_TipCard_Remarketing_Tour_Title'),
    description: i18n.getString('Dashboard_TipCard_Remarketing_Tour_Desc'),
    helpLink: 144778,
    helpType: 'tour',
    imgClass: 'remarketing_tip_img',
  },
  902: {
    tipName: tipNames.remarketingHelp1,
    title: i18n.getString('Dashboard_TipCard_Remarketing_Help1_Title'),
    description: i18n.getString('Dashboard_TipCard_Remarketing_Help1_Desc'),
    helpLink: 'app54581',
    helpType: 'side_pane',
    imgClass: 'remarketing_tip_img',
  },
  903: {
    tipName: tipNames.remarketingVideo,
    title: i18n.getString('Dashboard_TipCard_Remarketing_Video_Title'),
    description: i18n.getString('Dashboard_TipCard_Remarketing_Video_Desc'),
    helpLink: 'PZZvA-X04-8',
    helpType: 'video',
    imgClass: 'remarketing_tip_img',
  },
  904: {
    tipName: tipNames.remarketingHelp2,
    title: i18n.getString('Dashboard_TipCard_Remarketing_Help2_Title'),
    description: i18n.getString('Dashboard_TipCard_Remarketing_Help2_Desc'),
    helpLink: 'app54582',
    helpType: 'side_pane',
    imgClass: 'remarketing_tip_img',
  },
  1001: {
    tipName: tipNames.autoBidHelp,
    title: i18n.getString('Dashboard_TipCard_AutoBid_Help_Title'),
    description: i18n.getString('Dashboard_TipCard_AutoBid_Help_Desc'),
    helpLink: 'app54580',
    helpType: 'side_pane',
    imgClass: 'autoBid_tip_img',
  },
  1002: {
    tipName: tipNames.autoBidMktg,
    title: i18n.getString('Dashboard_TipCard_AutoBid_Mktg_Title'),
    description: i18n.getString('Dashboard_TipCard_AutoBid_Mktg_Desc'),
    helpLink: 'https://advertise.bingads.microsoft.com/en-us/blog/post/august-2016/get-more-conversions-with-the-new-enhanced-cpc-bid-strategy',
    helpType: 'new_page',
    imgClass: 'autoBid_tip_img',
  },
  1101: {
    tipName: tipNames.sharedBudgetsHelp,
    title: i18n.getString('Dashboard_TipCard_SharedBudgets_Help_Title'),
    description: i18n.getString('Dashboard_TipCard_SharedBudgets_Help_Desc'),
    helpLink: 'app54584',
    helpType: 'side_pane',
    imgClass: 'sharedBudgets_tip_img',
  },
  1201: {
    tipName: tipNames.callMktg,
    title: i18n.getString('Dashboard_TipCard_Call_Mktg_Title'),
    description: i18n.getString('Dashboard_TipCard_Call_Mktg_Desc'),
    helpLink: 'https://advertise.bingads.microsoft.com/en-us/solutions/ad-extensions/call-extensions',
    helpType: 'new_page',
    imgClass: 'call_tip_img',
  },
  1202: {
    tipName: tipNames.callHelp,
    title: i18n.getString('Dashboard_TipCard_Call_Help_Title'),
    description: i18n.getString('Dashboard_TipCard_Call_Help_Desc'),
    helpLink: 'app54576',
    helpType: 'side_pane',
    imgClass: 'call_tip_img',
  },
  1301: {
    tipName: tipNames.reviewsMktg,
    title: i18n.getString('Dashboard_TipCard_Reviews_Mktg_Title'),
    description: i18n.getString('Dashboard_TipCard_Reviews_Mktg_Desc'),
    helpLink: 'https://advertise.bingads.microsoft.com/en-us/solutions/ad-extensions/review-extensions',
    helpType: 'new_page',
    imgClass: 'reviews_tip_img',
  },
  1302: {
    tipName: tipNames.reviewsHelp,
    title: i18n.getString('Dashboard_TipCard_Reviews_Help_Title'),
    description: i18n.getString('Dashboard_TipCard_Reviews_Help_Desc'),
    helpLink: 'app54579',
    helpType: 'side_pane',
    imgClass: 'reviews_tip_img',
  },
  1401: {
    tipName: tipNames.kWMatchTypeHelp,
    title: i18n.getString('Dashboard_TipCard_KWMatchType_Help_Title'),
    description: i18n.getString('Dashboard_TipCard_KWMatchType_Help_Desc'),
    helpLink: 'app54583',
    helpType: 'side_pane',
    imgClass: 'kWMatchType_tip_img',
  },
  1402: {
    tipName: tipNames.kWMatchTypeMktg,
    title: i18n.getString('Dashboard_TipCard_KWMatchType_Mktg_Title'),
    description: i18n.getString('Dashboard_TipCard_KWMatchType_Mktg_Desc'),
    helpLink: 'https://advertise.bingads.microsoft.com/en-us/resources/training/keyword-match-options',
    helpType: 'new_page',
    imgClass: 'kWMatchType_tip_img',
  },
  1501: {
    tipName: tipNames.negKWHelp1,
    title: i18n.getString('Dashboard_TipCard_NegKW_Help1_Title'),
    description: i18n.getString('Dashboard_TipCard_NegKW_Help1_Desc'),
    helpLink: 'app54586',
    helpType: 'side_pane',
    imgClass: 'negKW_tip_img',
  },
  1502: {
    tipName: tipNames.negKWHelp2,
    title: i18n.getString('Dashboard_TipCard_NegKW_Help2_Title'),
    description: i18n.getString('Dashboard_TipCard_NegKW_Help2_Desc'),
    helpLink: 'app54587',
    helpType: 'side_pane',
    imgClass: 'negKW_tip_img',
  },
  1601: {
    tipName: tipNames.broadMatchHelp,
    title: i18n.getString('Dashboard_TipCard_BroadMatch_Help_Title'),
    description: i18n.getString('Dashboard_TipCard_BroadMatch_Help_Desc'),
    helpLink: 'app54583',
    helpType: 'side_pane',
    imgClass: 'broadMatch_tip_img',
  },
  1701: {
    tipName: tipNames.ScheduledImportHelp,
    title: i18n.getString('Dashboard_TipCard_ScheduledImport_Help_Title'),
    description: i18n.getString('Dashboard_TipCard_ScheduledImport_Help_Desc'),
    helpLink: 'app54497',
    helpType: 'side_pane',
    imgClass: 'import_tip_img',
    isImportRelatedTip: true,
  },
  1801: {
    tipName: tipNames.ReImportRSACampaigns,
    title: i18n.getString('Dashboard_TipCard_RSA_Import_Help1_Title'),
    description: i18n.getString('Dashboard_TipCard_RSA_Import_Help1_Desc'),
    helpLink: 'app54667',
    helpType: 'side_pane',
    imgClass: 'import_tip_img',
    isImportRelatedTip: true,
  },
  1901: {
    tipName: tipNames.IncludeRSACampaigns,
    title: i18n.getString('Dashboard_TipCard_RSA_Import_Help2_Title'),
    description: i18n.getString('Dashboard_TipCard_RSA_Import_Help2_Desc'),
    helpLink: 'app54667',
    helpType: 'side_pane',
    imgClass: 'import_tip_img',
    isImportRelatedTip: true,
  },
  2001: {
    tipName: tipNames.IncludeMultiAccountGoogleImport,
    title: i18n.getString('Dashboard_TipCard_Multi_Account_Import_Help1_Title'),
    description: i18n.getString('Dashboard_TipCard_Multi_Account_Import_Help1_Desc'),
    helpLink: 'app54577',
    helpType: 'side_pane',
    imgClass: 'import_tip_img',
    isImportRelatedTip: true,
  },
  2101: {
    tipName: tipNames.ProvideStoreToImportShoppingCampaign,
    title: i18n.getString('Dashboard_TipCard_Provide_Store_To_Import_Shopping_Campaign_Help_Title'),
    description: i18n.getString('Dashboard_TipCard_Provide_Store_To_Import_Shopping_Campaign_Help_Desc'),
    helpLink: 'app51001',
    helpType: 'side_pane',
    imgClass: 'import_tip_img',
    isImportRelatedTip: true,
  },
  2201: {
    tipName: tipNames.SelectAdCusFeedToImportEXTA,
    title: i18n.getString('Dashboard_TipCard_Select_AdCusFeed_To_Import_EXTA_Help_Title'),
    description: i18n.getString('Dashboard_TipCard_Select_AdCusFeed_To_Import_EXTA_Help_Desc'),
    helpLink: 'app54730',
    helpType: 'side_pane',
    imgClass: 'import_tip_img',
    isImportRelatedTip: true,
  },
  2301: {
    tipName: tipNames.FacebookImport,
    title: i18n.getString('Dashboard_TipCard_FB_Import_Help_Title'),
    description: i18n.getString('Dashboard_TipCard_FB_Import_Help_Desc'),
    helpLink: 'app54769',
    helpType: 'side_pane',
    imgClass: 'import_tip_img',
    isImportRelatedTip: true,
  },
  2401: {
    tipName: tipNames.UETCombineClarity,
    title: i18n.getString('Dashboard_TipCard_UETCombineClarity_Help_Title'),
    description: i18n.getString('Dashboard_TipCard_UETCombineClarity_Help_Desc'),
    helpLink: 'https://help.ads-int.microsoft.com/#apex/3/en/60110/-1/en/#ext:Default',
    helpType: 'new_page',
    imgClass: 'conversionTracking_tip_img',
  },
};
